export enum CheckBoxVariant {
  WithColoredBorder = "withColoredBorder",
  Regular = "regular",
  Large = "large",
}
